import { render, staticRenderFns } from "./NewActor_NewVIP.vue?vue&type=template&id=66b211bf&scoped=true"
import script from "./NewActor_NewVIP.vue?vue&type=script&lang=js"
export * from "./NewActor_NewVIP.vue?vue&type=script&lang=js"
import style0 from "./NewActor_NewVIP.vue?vue&type=style&index=0&id=66b211bf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b211bf",
  null
  
)

export default component.exports